<template>
  <x-dialog v-model="display" class="confirm-dialog">
    <p>认证成功</p>
    <button @click="jump2activity">
      {{ $theme.successDialogBtnLabel }}
    </button>
  </x-dialog>
</template>

<script>
export default {
  data() {
    return {
      display: false,
    }
  },
  methods: {
    show() {
      this.display = true
    },
    hide() {
      this.display = false
    },
    jump2activity() {
      window.$bus.$emit('jump2activity', this.$theme.successDialogBtnUrl)
    },
  },
}
</script>

<style lang="less">
.confirm-dialog {
  .zg_dialog {
    width: 270px;
    color: #030303;
    padding: 20px 15px;
    border-radius: 12px;
  }
}
</style>

<style lang="less" scoped>
.confirm-dialog {
  p {
    font-size: 16px;
    margin-bottom: 16px;
  }
  button {
    border-radius: 4px;
    font-weight: bold;
    width: 100%;
    height: 40px;
    background: linear-gradient(270deg, #fecd0f 0, #ffdf62);
  }
}
</style>
